// src/components/FileExplorer.js
import React from 'react';
import './FileExplorer.css';
import FilesToolbar from '../FilesToolbar/FilesToolbar';
import FileGrid from '../FileGrid/FileGrid';
import FilesBreadcrumb from '../FilesBreadcrumb/FilesBreadcrumb';
import FilesSearchBar from '../FilesSearchBar/FilesSearchBar';
import FileDetailsView from '../FileDetailsView/FileDetailsView';

const FileExplorer = ({ 
    files, 
    onAddFileClick, 
    selectedItems, 
    onAddFolderClick, 
    onItemClick, 
    onItemDoubleClick, 
    onContainerClick, 
    path, 
    currentItem, 
    cutCopyEnabled,
    pasteEnabled,
    onNavigate, 
    onSearch, 
    onDragStart, 
    onDragOver, 
    onDrop, 
    onCutClick,
    onCopyClick,
    onPasteClick,
    onSort,
    onDelete,
    view,
    switchView,
    onFilesDropped, // Add this prop
    activeTab,
    configParameters
}) => {

    const handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = Array.from(e.dataTransfer.files);
        onFilesDropped(files);
    };

    return (
        <div className="file-explorer">
            <div className='d-flex justify-content-between align-items-center mb-3'>
            <FilesBreadcrumb path={path} currentItem={currentItem} onNavigate={onNavigate} />
            <FilesSearchBar onSearch={onSearch} />
            </div>
            <FilesToolbar 
                onAddFile={onAddFileClick} 
                onAddFolder={onAddFolderClick} 
                onCut={onCutClick}
                onCopy={onCopyClick}
                onPaste={onPasteClick}
                onSort={onSort}
                onDelete={onDelete}
                cutCopyEnabled={cutCopyEnabled}
                pasteEnabled={pasteEnabled}
                switchView={switchView}
                canWrite={activeTab !== 'swm' && activeTab !== 'ex' && configParameters.EnableFileUploads == 'true' }
            />
            {view == "grid" ? (
                <FileGrid
                    files={files}
                    selectedItems={selectedItems}
                    onItemClick={onItemClick}
                    onItemDoubleClick={onItemDoubleClick}
                    onContainerClick={onContainerClick}
                    onDragStart={onDragStart}
                    onDragOver={onDragOver}
                    onDrop={onDrop}
                    onContainerDragOver={handleDragOver}
                    onContainerDrop={handleDrop}
                />
            ) : (
                <FileDetailsView
                    files={files}
                    selectedItems={selectedItems}
                    onItemClick={onItemClick}
                    onItemDoubleClick={onItemDoubleClick}
                    onContainerClick={onContainerClick}
                    onDragStart={onDragStart}
                    onDragOver={onDragOver}
                    onDrop={onDrop}
                    onContainerDragOver={handleDragOver}
                    onContainerDrop={handleDrop}
                />
            )}
        </div>
    );
};

export default FileExplorer;
